export const PARTNERS = {
  PREMIUM: 'premium',
  GHC: 'GHC',
  MOSGORTOUR: 'mosgortour',
  MOSGORTOUR_MANAGER: 'mosgortour_manager',
  ALFA: 'alfa',
  SUTOCHNO: 'sutochno',
  TBANK: 'tbank',
  TRAVELBELKA: 'travelbelka',
  COSMOS_TRAVEL: 'cosmos_travel',
} as const;

export const PARTNER_IDS = {
  [PARTNERS.PREMIUM]: 1305,
  [PARTNERS.GHC]: 1186,
  [PARTNERS.MOSGORTOUR]: 1297,
  [PARTNERS.MOSGORTOUR_MANAGER]: 1306,
  [PARTNERS.ALFA]: 1220,
  [PARTNERS.SUTOCHNO]: 1168,
  [PARTNERS.TBANK]: 1190,
  [PARTNERS.TRAVELBELKA]: 118,
  [PARTNERS.COSMOS_TRAVEL]: 1320,
} as const;

export type PartnerCode = (typeof PARTNERS)[keyof typeof PARTNERS];
